import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useServices } from 'index';
import { isTrackmanParametersV2Enabled } from 'utilities/enabledFeaturesHelper';
import { ParameterCategoryResponseV2, ParameterCategoryView, ParametersList } from 'types/trackmanParameters';
import { mapV1ToView, mapV2ToView } from './mapToView';

export const useParameterCategories = (useV2?: boolean) => {
  const { trackmanParametersService, trackmanParametersV2PublicService } = useServices();
  const { t } = useTranslation();

  const isV2 = useV2 ?? isTrackmanParametersV2Enabled;

  return useQuery<ParametersList | ParameterCategoryResponseV2[], Error, ParameterCategoryView[]>({
    queryKey: isV2 ? ['trackmanParameters', 'v2'] : ['trackmanParameters', 'v1'],
    queryFn: isV2 ? trackmanParametersV2PublicService.getTrackmanParameters : trackmanParametersService.getTrackmanParameters,
    refetchOnWindowFocus: false,
    select: isV2
      ? (data) => mapV2ToView(data as ParameterCategoryResponseV2[])
      : (data) => mapV1ToView(data as ParametersList, t),
  });
};
